import React from 'react';
import { MdDone } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
import {
  Container, Content, ContentContainer, Header, Price, Title, Parcel,
  LoginContainer,
  LoginText,
} from './styles';
import theme from '../../theme';
import ModalButton from '../ModalButton';
import { VirtualRaceType } from '../../types/VirtualRace';

interface Props {
  virtualRace: VirtualRaceType
}

export default function VirtualRaceSubscriptionCard({ virtualRace }: Props) {
  const auth = useSelector((state: RootState) => state.auth);
  const { token } = auth;

  const navigate = useNavigate();

  const redirectToPayment = () => {
    const tok = token ? `?token=${token}` : '';
    window.open(`https://pay.corridaperfeita.com/pay/product/${virtualRace.slug}/${tok}`);
  };

  const redirectToLogin = () => {
    auth.path = `/club/prova-virtual/${virtualRace.slug}`;
    navigate('/login');
  };

  return (
    <Container>
      <Header>
        <Title>Inscrição + Medalha</Title>
        <Price>{`R$ ${virtualRace.price.toFixed(2)}`}</Price>
        {virtualRace.installments > 1 && <Parcel>{`em até ${virtualRace.installments} X ${(virtualRace.price / virtualRace.installments).toFixed(2)}`}</Parcel>}
        {/* <PriceInfo>+ Frete conforme seu CEP</PriceInfo> */}
      </Header>
      {virtualRace.subscriptionCustomItems?.map((item, index) => (
        <ContentContainer key={index}>
          <MdDone size={18} color={theme.colors.graph} />
          <Content>{item}</Content>
        </ContentContainer>
      ))}

      <ModalButton title="INSCREVA-SE AGORA" onPress={redirectToPayment} style={{ padding: 8, margin: 23 }} />

      {!token && (
        <LoginContainer>
          <LoginText>Já fez sua inscrição?</LoginText>
          <ModalButton title="ACOMPANHE SUA CORRIDA VIRTUAL" onPress={redirectToLogin} style={{ padding: 8 }} secondary />
        </LoginContainer>
      )}
    </Container>
  );
}
